// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-5c714f6b] .el-dialog{width:auto;min-width:50%!important;max-width:78%!important}.tab_box[data-v-5c714f6b]{border:1px solid #d2d2d2}.tab_box .size_tab_pane[data-v-5c714f6b]{padding:15px 31px}[data-v-5c714f6b] .el-tabs__nav{width:100%}[data-v-5c714f6b] .el-tabs__item{width:16.75%;text-align:center;border-right:1px solid #d2d2d2!important}[data-v-5c714f6b] .el-tabs__nav .el-tabs__item:last-child{border-right:none!important}", ""]);
// Exports
module.exports = exports;
